/**
 * Collapses the same read fired twice in one render pass.
 *
 * Two things ask for a list or an entity at once more often than it looks: a page
 * and a panel inside it both declare they need the module's comments; a saga
 * reacting to the selected module fires the same list the panel's hook does. Each
 * of those is right on its own, and none of them can see the others.
 *
 * The window is deliberately short — long enough to collapse one pass, not long
 * enough to swallow a deliberate re-fetch after a write.
 */
const recentRequests = new Map<string, number>();

const DEDUPE_WINDOW_MS = 750;

/**
 * True when this request should go out, false when an identical one just did.
 * Records the request as it answers, so callers must not call it speculatively.
 */
export function shouldRequest(key: string): boolean {
  const now = Date.now();
  const lastRequestedAt = recentRequests.get(key);

  if (lastRequestedAt && now - lastRequestedAt < DEDUPE_WINDOW_MS) return false;

  recentRequests.set(key, now);

  return true;
}
